import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import '../../Styles/SuperAdminHeader.scss'
import {  Link,NavLink,Redirect, Route } from "react-router-dom";
import Images from "../../Assets/Images";
import { BrowserRouter as Router, Switch} from "react-router-dom";
import { renderRoutes } from 'react-router-config';
// import {superAdminDashboardRoute} from '../../Routes/RoutesPath';
import {history} from '../../Routes/history';
import { Dropdown } from 'react-bootstrap';
import SuperAdminTenantHome from '../../Screens/SuperAdmin/SuperAdminTenantHome'
// import createHistory from 'history/createBrowserHistory';
// const history = useHistory();   
// import { createBrowserHistory } from 'history';
// const history = createBrowserHistory();


export default class SuperAdminHeader extends Component {

  componentDidMount() {
  }

  componentWillUnmount(){
    
  }
  pageNavLogout = () =>{
    // secureLocalStorage.clear()
    // this.props.history.push("/"); 
    window.location.href="/";
  }

  check =()=>{
    // this.props.history.push('/')
    history.push('/superadmin/home')
  }
  
  render() {
    
    return (
      
      <div className="appWrapper">
        <div className="sidebar ">
          <div className="sbFixed">
            <div className="menuItems">
              <div className="logoCont">
                <img src={Images.RISKWELLLOGO} alt="logo" />
              </div>

              <ul>
                <li className="active">
                  <a>
                    <span className="navIcon">
                      <img src={Images.TENANT} width="16" alt="User" />
                    </span>
                    {/* <button onClick={()=>{this.check()}}>
                      Tenant
                      </button> */}
                    <Link className="navCont"  to="/superadmin/home"> 
                      Tenant
                    </Link>
                  </a>
                </li>

                {/* <li>
                  <a onClick={this.pageNavUser}>
                    <span className="navIcon">
                      <img src={Images.USER} width="16" alt="User" />
                    </span>
                    <NavLink className="navCont" exact to="/">
                      User
                    </NavLink>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="wrapper">
          <div className="appHeader d-flex">
            <div className="heading">Tenant</div>
            <div className="ml-auto">
              <div className="proImg">
                 <Dropdown>
                      <Dropdown.Toggle>
                    <div className="profileImg">
                      <img src={Images.AVATAR} width="22" alt="Profile" />
                    </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                    <Dropdown.Item onClick={this.pageNavLogout}><img src={Images.LOGOUT} width="14" alt="Profile"/>Logout</Dropdown.Item>
                  {/* <Dropdown.Item onClick={this.pageNav}> <img src={Images.PASSWORD} width="14" alt="Password" /> Change Password</Dropdown.Item> */}
                  </Dropdown.Menu>
                  </Dropdown> 
              </div>
            </div>
          </div>

          <div className="appCont">
            <a>
              <SuperAdminTenantHome/>
            {/* <Router history={history}>
                    <Route>
                        {renderRoutes(superAdminDashboardRoute)}
                    </Route>
                </Router> */}
                </a>
          </div>
        </div>
      </div> 
    )
  }
}
